export default "__VITE_ASSET__b0f0d8af__"